import useCustomer from 'src/app/customers/hooks/useCustomer';
import { useGetPortfolioRiskStatsQuery } from 'src/app/portfolio/state/api/riskInsightsEngineSlice';

/**
 * Whether the current organisation has Global Nature Risk results: at least
 * one site with a current risk summary. An organisation can be onboarded into
 * the engine before it has any.
 *
 * `undefined` while that is unknown, so `useProductAccess` reports `LOADING`.
 * A failed request and an organisation the engine does not know both count as
 * no results, so the customer gets the upsell.
 */
const useHasRiskResults = (): boolean | undefined => {
    const { currentCustomerId } = useCustomer();
    const { data, isLoading, isError } = useGetPortfolioRiskStatsQuery(
        { businessCentralId: currentCustomerId ?? '' },
        { skip: !currentCustomerId }
    );

    if (!currentCustomerId || isLoading) {
        return undefined;
    } else if (isError) {
        return false;
    } else if (data) {
        return (data.organisation?.portfolioRiskStats.assessedSiteCount ?? 0) > 0;
    } else {
        return undefined;
    }
};

export default useHasRiskResults;
